<template>
  <b-modal
    ref="modal-follow-up"
    hide-footer
    :title="tituloModal"
    size="xl"
    @show="onModalShow"
    @hidden="onModalHidden"
  >
    <!-- Form envolve TUDO relacionado ao follow-up -->
    <b-form @submit.prevent="salvarFollowUp">
      <!-- Informações do Candidato -->
      <div class="mb-3 p-3 bg-light rounded">
        <div class="d-flex align-items-start">
          <b-avatar :src="candidato.urlFotoPerfil" size="3rem" class="mr-3" />
          <div class="flex-grow-1">
            <h6 class="mb-1">{{ candidato.nome }}</h6>
            <div class="d-flex align-items-center">
              <small class="text-muted">{{ candidato.email }}</small>
              <b-badge
                v-if="candidato.statusDescricao"
                :style="{ backgroundColor: candidato.statusCor || '#6c757d' }"
                class="ml-3"
              >
                {{ candidato.statusDescricao }}
              </b-badge>
            </div>
            <div class="mt-1">
              <small class="text-muted">
                <strong>Responsável:</strong>
                {{ formatarResponsavelTipo(candidato.responsavelTipo) }}
              </small>
              <small class="text-muted ml-3" v-if="candidato.prazoPadrao">
                <strong>Prazo padrão:</strong> {{ candidato.prazoPadrao }}
                {{ formatarTipoCalculoPrazo(candidato.tipoCalculoPrazo) }}
              </small>
            </div>

          </div>
          <!-- Prazo Container - Sempre visível se candidato tem data_base -->
          <div class="prazo-container" v-if="candidato.data_base">
            <div class="d-flex align-items-start">
              <!-- Prazo Atual - Sempre visível -->
              <div class="prazo-box mr-3">
                <small class="d-block font-weight-bold">Prazo atual:</small>
                <span class="text-danger">{{
                  formatarData(candidato.data_base)
                }}</span>
                <small class="d-block text-muted"
                  >({{ getDiasVencido(candidato) }} dias em atraso)</small
                >
              </div>
              <!-- Novo Prazo - Apenas no modo 1 (com prorrogação) -->
              <div class="prazo-box" v-if="permiteProrrogacao">
                <small class="d-block font-weight-bold mb-1">Novo prazo:</small>
                <b-form-input
                  v-model="followUpForm.dataEspecifica"
                  type="date"
                  :min="dataMinima"
                  :disabled="solicitacaoConcluida"
                  size="sm"
                  style="width: 150px"
                >
                </b-form-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SEÇÃO 1: Novo Follow-up -->
      <div class="follow-up-section mb-4">
        <h6 class="section-title mb-3">Novo Follow-up</h6>

        <!-- Comentário -->
        <b-form-group label="Comentário:" label-for="comentario">
          <b-form-textarea
            id="comentario"
            v-model="followUpForm.justificativa"
            rows="4"
            required
            :disabled="solicitacaoConcluida"
            :placeholder="modoFollowUp === 2
              ? 'Registre observações sobre este prazo...'
              : 'Descreva o motivo da prorrogação...'"
          ></b-form-textarea>
          <small class="form-text text-muted">
            Mínimo 10 caracteres, máximo 500 caracteres
          </small>
        </b-form-group>

        <!-- Botões de Ação -->
        <b-row class="mt-4">
          <div class="col-6">
            <b-button
              variant="success"
              type="submit"
              block
              :disabled="followUpForm.salvando || solicitacaoConcluida"
            >
              <b-spinner small v-if="followUpForm.salvando"></b-spinner>
              {{
                followUpForm.salvando ? "Salvando..." : textoBotaoConfirmar
              }}
            </b-button>
          </div>
          <div class="col-6">
            <b-button variant="outline-secondary" block @click="fecharModal">
              Cancelar
            </b-button>
          </div>
        </b-row>
      </div>
    </b-form>

    <!-- Divisor -->
    <hr class="my-4" />

    <!-- SEÇÃO 2: Histórico de Follow-ups -->
    <div class="follow-up-section">
      <h6 class="section-title mb-3">Histórico de Follow-ups</h6>

      <div v-if="carregandoHistorico" class="text-center p-4">
        <b-spinner></b-spinner>
        <p class="mt-2">Carregando histórico...</p>
      </div>

      <div v-else-if="historicoFollowUps.length === 0" class="text-center p-4">
        <p class="text-muted">
          Nenhum follow-up encontrado para este candidato.
        </p>
      </div>

      <div v-else class="historico-scroll">
        <b-table
          striped
          hover
          :fields="fieldsHistorico"
          :items="historicoFollowUps"
          small
          class="table-sticky mb-0"
        >
          <template v-slot:cell(comentario)="data">
            <div
              style="
                white-space: pre-line;
                word-wrap: break-word;
                max-width: 300px;
              "
              :id="'tooltip-comentario-' + data.index"
              v-if="data.item.justificativa && data.item.justificativa !== '-'"
            >
              {{ data.item.justificativa }}
              <b-tooltip
                :target="'tooltip-comentario-' + data.index"
                placement="top"
                boundary="viewport"
                custom-class="tooltip-comentario-largo"
              >
                <div style="white-space: pre-line; text-align: left">
                  {{ data.item.justificativa }}
                </div>
              </b-tooltip>
            </div>
            <div
              v-else
              style="
                white-space: pre-line;
                word-wrap: break-word;
                max-width: 300px;
              "
            >
              -
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from "@/services/api";
import dayjs from "dayjs";
import validaCredencial from "../../pages/web_cliente/utils";

export default {
  name: "ModalFollowUp",

  props: {
    candidato: {
      type: Object,
      default: () => ({}),
    },
    modoFollowUp: {
      type: Number,
      default: 0, // 0, 1 ou 2
    },
  },

  data() {
    return {
      followUpForm: {
        metodoProrrogacao: "data", // 'dias' ou 'data'
        diasProrrogacao: "",
        dataEspecifica: "",
        justificativa: "",
        salvando: false,
      },

      opcoesProrrogacao: [
        { text: "Definir data específica", value: "data" },
        { text: "Adicionar dias úteis", value: "dias" },
      ],

      historicoFollowUps: [],
      carregandoHistorico: false,
    };
  },

  computed: {
    tituloModal() {
      return this.modoFollowUp === 2
        ? "Follow-up - Registro de Comentário"
        : "Follow-up - Prorrogação de Prazo";
    },

    permiteProrrogacao() {
      return this.modoFollowUp === 1;
    },

    dataMinima() {
      if (!this.permiteProrrogacao) return null;
      const hoje = dayjs();
      return hoje.format("YYYY-MM-DD");
    },

    previewNovaData() {
      if (this.followUpForm.metodoProrrogacao === "dias") {
        return this.calcularNovaDataBasePorDias();
      } else if (this.followUpForm.metodoProrrogacao === "data") {
        return this.calcularNovaDataBasePorData();
      }
      return "";
    },

    solicitacaoConcluida() {
      return !this.candidato.data_base;
    },

    textoBotaoConfirmar() {
      return this.modoFollowUp === 2
        ? "Registrar Comentário"
        : "Confirmar Prorrogação";
    },

    fieldsHistorico() {
      const baseFields = [
        { key: "dataAtualizacao", label: "Data/Hora", sortable: true },
        { key: "usuarioNome", label: "Usuário", sortable: true },
        {
          key: "responsavelTipo",
          label: "Responsável",
          sortable: true,
          formatter: (value) => {
            if (value === "cooperado") return "Cooperado";
            if (value === "cooperativa") return "Cooperativa";
            if (value === "cooperado.") return "Cooperado.";
            return value || "-";
          },
        },
      ];

      // Colunas de prazo variam conforme o modo
      if (this.permiteProrrogacao) {
        // Modo 1: Mostra "Prazo Anterior" e "Novo Prazo"
        baseFields.push(
          { key: "dataBaseAnterior", label: "Prazo Anterior", sortable: true },
          { key: "dataBaseNova", label: "Novo Prazo", sortable: true }
        );
      } else if (this.modoFollowUp === 2) {
        // Modo 2: Mostra apenas "Prazo" (sem a palavra "Anterior")
        baseFields.push(
          { key: "dataBaseAnterior", label: "Prazo", sortable: true }
        );
      }

      // Coluna de comentário sempre presente
      baseFields.push({
        key: "comentario",
        label: "Comentário",
        thStyle: { minWidth: "200px" },
      });

      return baseFields;
    },
  },

  methods: {
    async mostrarModal() {
      // Validar credenciais apenas para a funcionalidade (não para visualizar)
      const acessoPermitido = await validaCredencial(130);
      if (acessoPermitido === "fail") {
        this.msg(
          "ATENÇÃO",
          "Você não possui permissão para acessar follow-ups.",
          "warning",
          5000
        );
        return;
      }

      // Sempre permitir abrir o modal para ver histórico
      // A validação de pendente será feita na aba específica
      this.$refs["modal-follow-up"].show();
    },

    fecharModal() {
      this.$refs["modal-follow-up"].hide();
    },

    onModalShow() {
      // Limpar formulário
      this.followUpForm.metodoProrrogacao = "data";
      this.followUpForm.diasProrrogacao = "";
      this.followUpForm.dataEspecifica = "";
      this.followUpForm.justificativa = "";
      this.followUpForm.salvando = false;

      // Carregar histórico
      this.carregarHistorico();
    },

    onModalHidden() {
      // Limpar dados quando modal fechar
      this.historicoFollowUps = [];
    },

    async carregarHistorico() {
      if (!this.candidato.id) return;

      this.carregandoHistorico = true;

      try {
        const response = await api.get(
          `web-cliente/candidato/historico/${this.candidato.id}/status/30`
        );
        this.historicoFollowUps = response.data;
      } catch (error) {
        console.error("Erro ao carregar histórico:", error);
        this.msg(
          "ERRO",
          "Erro ao carregar histórico de follow-ups.",
          "danger",
          3000
        );
      } finally {
        this.carregandoHistorico = false;
      }
    },

    async salvarFollowUp() {
      // Validações APENAS se permitir prorrogação (modo === 1)
      if (this.permiteProrrogacao) {
        if (this.followUpForm.metodoProrrogacao === "dias") {
          if (!this.followUpForm.diasProrrogacao) {
            this.msg(
              "ATENÇÃO",
              "Informe os dias de prorrogação.",
              "warning",
              3000
            );
            return;
          }
        } else if (this.followUpForm.metodoProrrogacao === "data") {
          if (!this.followUpForm.dataEspecifica) {
            this.msg("ATENÇÃO", "Selecione o novo prazo.", "warning", 3000);
            return;
          }

          // Validar se a data é hoje ou posterior
          const dataEscolhida = dayjs(this.followUpForm.dataEspecifica);
          const hoje = dayjs().startOf("day");
          if (dataEscolhida.isBefore(hoje, "day")) {
            this.msg(
              "ATENÇÃO",
              "O novo prazo não pode ser anterior a hoje.",
              "warning",
              3000
            );
            return;
          }
        }
      }

      // Validação de comentário (sempre obrigatório)
      if (!this.followUpForm.justificativa) {
        this.msg("ATENÇÃO", "Informe o comentário.", "warning", 3000);
        return;
      }

      if (this.followUpForm.justificativa.length < 10) {
        this.msg(
          "ATENÇÃO",
          "O comentário deve ter pelo menos 10 caracteres.",
          "warning",
          3000
        );
        return;
      }

      this.followUpForm.salvando = true;

      try {
        const payload = {
          idSolicitacao: this.candidato.id,
          justificativa: this.followUpForm.justificativa,
        };

        // Incluir dados de prorrogação APENAS se modo === 1
        if (this.permiteProrrogacao) {
          payload.metodoProrrogacao = this.followUpForm.metodoProrrogacao;

          if (this.followUpForm.metodoProrrogacao === "dias") {
            payload.diasProrrogacao = this.followUpForm.diasProrrogacao;
          } else {
            payload.dataEspecifica = this.followUpForm.dataEspecifica;
          }
        }

        const response = await api.post("web-cliente/candidato/follow-up", payload);

        this.msg(
          "SUCESSO",
          response.data.message || "Operação realizada com sucesso.",
          "success",
          3000
        );

        // Recarregar histórico
        await this.carregarHistorico();

        // Emitir evento para atualizar a lista principal
        this.$emit("follow-up-criado");

        // Limpar formulário
        this.followUpForm.metodoProrrogacao = "data";
        this.followUpForm.diasProrrogacao = "";
        this.followUpForm.dataEspecifica = "";
        this.followUpForm.justificativa = "";

        // Fechar modal após sucesso
        this.fecharModal();
      } catch (error) {
        if (error.response && error.response.data) {
          this.msg("ERRO", error.response.data, "danger", 5000);
        } else {
          this.msg(
            "ERRO",
            "Erro na operação. Tente novamente.",
            "danger",
            5000
          );
        }
      } finally {
        this.followUpForm.salvando = false;
      }
    },

    formatarData(data) {
      if (!data) return "-";
      return dayjs(data).format("DD/MM/YYYY");
    },

    formatarDataHora(data) {
      if (!data) return "-";
      return dayjs(data).format("DD/MM/YYYY HH:mm");
    },

    formatarResponsavelTipo(tipo) {
      if (tipo === "cooperado") return "Cooperado";
      if (tipo === "cooperativa") return "Cooperativa";
      if (tipo === "cooperado.") return "Cooperado.";
      return tipo || "-";
    },

    formatarTipoCalculoPrazo(tipo) {
      if (!tipo) return "dia(s)";
      if (tipo === "dias_uteis") return "dia(s) útil(eis)";
      if (tipo === "dias_corridos") return "dia(s) corrido(s)";
      return "dia(s)";
    },

    calcularNovaDataBasePorData() {
      if (!this.followUpForm.dataEspecifica) {
        return "";
      }

      return dayjs(this.followUpForm.dataEspecifica).format("DD/MM/YYYY");
    },

    // Função para adicionar apenas dias úteis (exclui fins de semana)
    addBusinessDays(startDate, businessDays) {
      let currentDate = dayjs(startDate);
      let daysAdded = 0;

      while (daysAdded < businessDays) {
        currentDate = currentDate.add(1, "day");
        const dayOfWeek = currentDate.day();

        // Pula fins de semana (0 = domingo, 6 = sábado)
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          daysAdded++;
        }
      }

      return currentDate;
    },

    getDiasVencido(candidato) {
      if (!candidato.data_base) return 0;
      const hoje = dayjs();
      const dataBase = dayjs(candidato.data_base);
      return Math.max(0, hoje.diff(dataBase, "day"));
    },

    isPendente(candidato) {
      if (!candidato.data_base) return false;
      const hoje = dayjs();
      const dataBase = dayjs(candidato.data_base);
      return hoje.isAfter(dataBase);
    },

    msg(titulo, texto, cor, time = 10000) {
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: time,
        appendToast: true,
      });
    },
  },
};
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa !important;
}

.section-title {
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.alert-info {
  border-left: 4px solid #17a2b8;
}

.alert-warning {
  border-left: 4px solid #ffc107;
}

.prazo-container {
  min-width: 350px;
}

.prazo-box {
  text-align: left;
}

.historico-scroll {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  position: relative;
}

.historico-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.historico-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.historico-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.historico-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Tabela dentro do scroll */
.table-sticky {
  margin-bottom: 0 !important;
}

/* CRITICAL: Sticky header para TODAS as colunas thead th */
.historico-scroll :deep(table thead th) {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  background-color: #f8f9fa !important;
  border-top: none !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #dee2e6 !important;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1) !important;
}

/* Garante que o background seja sólido em todas as th */
.historico-scroll :deep(table thead) {
  background-color: #f8f9fa;
}

.historico-scroll :deep(table td) {
  vertical-align: middle;
}

/* Remove bordas extras que podem quebrar o sticky */
.historico-scroll :deep(table) {
  border-collapse: separate;
  border-spacing: 0;
}

hr {
  border-top: 2px solid #dee2e6;
}

/* Tooltip para comentários */
:deep(.tooltip-comentario-largo .tooltip-inner) {
  max-width: 600px !important;
  width: max-content !important;
  white-space: pre-line !important;
  text-align: left !important;
}

:deep(.tooltip-comentario-largo) {
  max-width: 600px !important;
}
</style>
